<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import cssVars from "css-vars-ponyfill";
export default {
  name: "App",
  beforeCreate() {
    if (this.$IVIEW && this.$IVIEW.themeColor) {
      let bodyStyles = document.body.style;
      bodyStyles.setProperty("--theme-color", this.$IVIEW.themeColor);
      // for IE
      // 不需要兼容IE浏览器的话可以去掉
      // cssVars({
      //   // Treat all browsers as legacy
      //   onlyLegacy: false,
      //   variables: {
      //     "--theme-color": this.$IVIEW.themeColor,
      //   },
      // });
    }
    const prefix = process.env.VUE_APP_AXIOS_BASE_URL ? "" : "portal";
    const link = document.getElementById("link");
    let pathUrl = window.location.href.split("#")[0];
    let length = pathUrl.split("/").length;
    let lastPart = pathUrl.split("/")[length - 1];
    let baseUrl = pathUrl.replace(lastPart, "");
    const logoImgUrl2 = prefix
      ? baseUrl + prefix + "/rs/logo/get?type=1&orderBy=1"
      : baseUrl + "rs/logo/get?type=1&orderBy=1";
    link.href = logoImgUrl2;
  },
};
</script>

<style lang="less" scpoed>
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: transparent;
  z-index: 10000;
}

//滚动轨道
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0 transparent;
  border-radius: 8px;
  background-color: transparent;
  z-index: 10000;
}

//滚动条
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  //-webkit-box-shadow: inset 0 0 6px #f7f7f7;
  background-color: #c9c9c9;
  z-index: 10000;
}
</style>
